import useInfrastructureChart from 'hooks/consume_api/query/useInfrastructureChart'
import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Button, Grid, TextField, Typography } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import { project as projectList } from './utils/dropDownData';
interface props {
    division: string,
    district: string,
    upazila: string,
    union: string,
    project: string
}
const Infrastructure: React.FC<props> = ({ division, district, upazila, union, project }) => {
    const [selectedProject, setSelectedProject] = useState(project);
    useEffect(() => {
        setSelectedProject(project);
    }, [project]);
    console.log('selectedProject', selectedProject);
    const { data } = useInfrastructureChart(selectedProject);
    console.log('Data=====', data);


    const subActivityRows = [
        {
            id: 57, // Establish Common Facility Center
            label: "Establish Common Facility Center on cost sharing",
            male_total: 0,
            female_total: 0,
            youth_members: 0,
            women_headed_households: 0,
            ethnic_members: 0
        },
        {
            id: 54, // Solar Pump
            label: "Solar Pump Based Solar home system ( Pumpset with Accessories ) supply with Installation",
            male_total: 0,
            female_total: 0,
            youth_members: 0,
            women_headed_households: 0,
            ethnic_members: 0
        },
        {
            id: 56, // Grassroots
            label: "Grassroots service outlets",
            male_total: 0,
            female_total: 0,
            youth_members: 0,
            women_headed_households: 0,
            ethnic_members: 0
        }
    ];

    const tableData = subActivityRows.map(row => {
        const apiRow = data?.data?.find((d: any) => d.sub_activity_name_id === row.id);
        return {
            ...row,
            male_total: apiRow?.male_total || 0,
            female_total: apiRow?.female_total || 0,
            youth_members: apiRow?.youth_members || 0,
            women_headed_households: apiRow?.women_headed_households || 0,
            ethnic_members: apiRow?.ethnic_members || 0
        };
    });



    const handleExport = (indicator: number) => {
        // let tableData: any = [];
        // if (indicator === 1) {
        //     tableData = [
        //         {
        //             "SubActivity": "Establish Common Facility Center on cost sharing",
        //             "Male": data?.data[0]?.male_total || 0,
        //             "Female": data?.data[0]?.female_total || 0,
        //             "Total": (Number(data?.data[0]?.male_total) + Number(data?.data[0]?.female_total)) || 0,
        //             "Youth Members": data?.data[0]?.youth_members || 0,
        //             "Women Headed Households": data?.data[0]?.women_headed_households || 0,
        //             "Ethnic Members": data?.data[0]?.ethnic_members || 0,
        //         },
        //         {
        //             "SubActivity": "Solar Pump Based Solar home system ( Pumpset with Accessories ) supply with Installation",
        //             "Male": data?.data[1]?.male_total || 0,
        //             "Female": data?.data[1]?.female_total || 0,
        //             "Total": (Number(data?.data[1]?.male_total) + Number(data?.data[1]?.female_total)) || 0,
        //             "Youth Members": data?.data[1]?.youth_members || 0,
        //             "Women Headed Households": data?.data[1]?.women_headed_households || 0,
        //             "Ethnic Members": data?.data[1]?.ethnic_members || 0,
        //         },
        //         {
        //             "SubActivity": "Grassroots service outlets",
        //             "Male": data?.data[2]?.male_total || 0,
        //             "Female": data?.data[2]?.female_total || 0,
        //             "Total": (Number(data?.data[2]?.male_total) + Number(data?.data[2]?.female_total)) || 0,
        //             "Youth Members": data?.data[2]?.youth_members || 0,
        //             "Women Headed Households": data?.data[2]?.women_headed_households || 0,
        //             "Ethnic Members": data?.data[2]?.ethnic_members || 0,
        //         }
        //     ];

        // }

        // const ws = XLSX.utils.json_to_sheet(tableData);
        // const wb = XLSX.utils.book_new();

        // XLSX.utils.book_append_sheet(wb, ws, 'Beneficiary Data');
        // XLSX.writeFile(wb, 'Project_activity_data.xlsx');
        const exportData = tableData.map(row => ({
            SubActivity: row.label,
            Male: row.male_total,
            Female: row.female_total,
            Total: Number(row.male_total) + Number(row.female_total),
            "Youth Members": row.youth_members,
            "Women Headed Households": row.women_headed_households,
            "Ethnic Members": row.ethnic_members
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Beneficiary Data');
        XLSX.writeFile(wb, 'Project_activity_data.xlsx');
    };
    return (
        data?.data?.length ? (
            <>
                {/* <Typography variant='h3' sx={{ marginTop: "20px" }}>Infrastructure Report</Typography> */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: "20px" }}>
                    <Typography variant="h3">Infrastructure Report</Typography>
                    <Autocomplete
                        options={projectList}
                        getOptionLabel={(option) => option.label}
                        value={projectList.find((item) => item.id === selectedProject) || null}
                        onChange={(event, value) => {
                            if (value) {
                                setSelectedProject(value.id);
                            } else {
                                setSelectedProject('-1');
                            }
                        }}
                        renderInput={(params) => <TextField {...params} label="Select project" variant="outlined" size="small" sx={{ width: 250 }} />}
                    />
                </Box>
                <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center", marginTop: "10px", marginBottom: "10px" }}>
                    <Button onClick={() => handleExport(1)}>Download</Button>
                </Box>
                <Grid marginTop="10px" item xs={12}>
                    <TableContainer component={Paper} sx={{ border: '1px solid black', borderRadius: '1px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Sub Activity</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Male</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Female</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Total</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Youth Members</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Women Headed Households</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black' }}>Ethnic Members</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* <TableRow>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>Establish Common Facility Center on cost sharing</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{data?.data[0]?.male_total}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{data?.data[0]?.female_total}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{Number(data?.data[0]?.male_total) + Number(data?.data[0]?.female_total)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{data?.data[0]?.youth_members}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{data?.data[0]?.women_headed_households}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black' }}>{data?.data[0]?.ethnic_members}</TableCell>

                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>Solar Pump Based Solar home system ( Pumpset with Accessories ) supply with Installation</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>{data?.data[1]?.male_total}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>{data?.data[1]?.female_total}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>{Number(data?.data[1]?.male_total) + Number(data?.data[1]?.female_total)}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>{data?.data[1]?.youth_members}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black', borderBottom: '1px solid black' }}>{data?.data[1]?.women_headed_households}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid black' }}>{data?.data[1]?.ethnic_members}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>Grassroots service outlets</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data[2]?.male_total}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data[2]?.female_total}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>{Number(data?.data[2]?.male_total) + Number(data?.data[2]?.female_total)}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data[2]?.youth_members}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid black' }}>{data?.data[2]?.women_headed_households}</TableCell>
                                    <TableCell >{data?.data[2]?.ethnic_members}</TableCell>

                                </TableRow> */}


                                {tableData.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.label}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.male_total}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.female_total}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{Number(row.male_total) + Number(row.female_total)}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.youth_members}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.women_headed_households}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid black' }}>{row.ethnic_members}</TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </TableContainer>

                </Grid >
            </>
        ) : null
    )

}

export default Infrastructure